import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDepartamentoUpd = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoUpd",
        params: {
            rnhDepartamentoId: data?.id,
            rnhDepartamentoCod: data?.cod,
            rnhDepartamentoNombre: data?.name,
            rnhDepartamentoDescripcion: data?.desc,
            rnhDepartamentoVersion: data?.version,
            rnhDepartamentoAdmiteRotativos: data?.admiteRotativos || null,
            rnhDepartamentoAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
